module.exports = __webpack_public_path__ + "assets/img/kh.f67fbb35.jpg";